export const MAX_INSIGHT_FILE_SIZE = 10 * 1024 * 1024;

export const VISIBLE_GOAL_COUNT = 10;

export const DRAG_ACTIVATION_DISTANCE = 8;

export const DEFAULT_QUERY_STALE_TIME = 30000;
export const EXTENDED_QUERY_STALE_TIME = 60000;

export const generateCustomGoalId = (): string => {
  return crypto.randomUUID();
};

export const TOOL_VERSIONS_CHANGED_EVENT = 'tool-versions-changed';

export const DIALOG_ACTION_BUTTON_CLASSNAME = 'flex-1 sm:flex-none h-11';
export const CONTEXT_SOURCES_URL_NOTE =
  "Add your product's website for Stella to use as context. Website scraping is coming soon. URLs are saved for your reference in the meantime.";

export const SHOW_ADD_CONTEXT_SOURCES_URL_TAB = false;

export const CONTEXT_SOURCES_FILE_FORMAT_NOTE =
  'Stella AI currently only uses Markdown (.md), Portable Document Format (.pdf), PowerPoint (.pptx), Text (.txt) and Word Document (.doc, .docx) files for context. You can still upload other formats — full support for those will be added soon.';

export const CONTEXT_SOURCES_FILE_UPLOAD_NOTE =
  'Uploaded documents — research reports, strategy decks, competitor analysis, or any supporting material — are used by Stella to analyze and coach you on your product.';
